import { Activity } from '../../core/activity.model';

/**
 * Real Sani Yusuf activities, used as a fallback so the dashboard renders
 * populated while the authed /activities API has no data (e.g. during the
 * temporary auth bypass). Once real activities exist they take precedence.
 *
 * Reach is NEVER stored — it is summed from each snapshot's `metrics` array.
 */
export const DEMO_ACTIVITIES: Activity[] = [
  {
    title: 'How I rebuilt our app in 2 weeks — against management orders',
    type: 'other',
    source: 'x',
    date: '2024-09-08T00:00:00.000Z',
    url: 'https://x.com/saniyusuf/status/1965378707922526709',
    tags: ['career', 'web'],
    metrics_list: [
      {
        captured_date: '2024-09-08T00:00:00.000Z',
        metrics: [
          { label: 'impressions', reach: 31000, is_manual: true },
          { label: 'likes', reach: 540, is_manual: true },
          { label: 'reposts', reach: 88, is_manual: true },
        ],
        fetched_via: 'manual',
      },
    ],
  },
  {
    title: '6 Apps One Code With Angular',
    type: 'video',
    source: 'youtube',
    date: '2018-04-20T00:00:00.000Z',
    url: 'https://www.youtube.com/watch?v=imaTBx4jbwY',
    thumbnail: 'https://i.ytimg.com/vi/imaTBx4jbwY/maxresdefault.jpg',
    tags: ['angular', 'mobile'],
    metrics_list: [
      {
        captured_date: '2018-04-20T00:00:00.000Z',
        metrics: [
          { label: 'views', reach: 12888, is_manual: false },
          { label: 'likes', reach: 286, is_manual: false },
          { label: 'comments', reach: 12, is_manual: false },
        ],
        fetched_via: 'yt_dlp',
      },
    ],
  },
  {
    title: 'ngAir 98 — PWAs and Mobile with Sani Yusuf',
    type: 'podcast',
    source: 'spotify',
    date: '2017-01-25T00:00:00.000Z',
    url: 'https://creators.spotify.com/pod/show/angularair/episodes/ngAir-98---PWAs-and-Mobile-with-Sani-Yusuf-ebh9qs',
    tags: ['angular', 'mobile'],
    metrics_list: [
      {
        captured_date: '2017-01-25T00:00:00.000Z',
        metrics: [{ label: 'plays', reach: 8200, is_manual: true }],
        fetched_via: 'manual',
      },
    ],
  },
  {
    title: 'The Power Of Collaboration',
    type: 'other',
    source: 'medium',
    date: '2017-01-09T00:00:00.000Z',
    url: 'https://medium.com/@saniyusuf/the-power-of-collaboration-f6dd11d8b262',
    thumbnail:
      'https://miro.medium.com/v2/resize:fit:700/1*6D00CvBM1XxtSnKSpPXcuQ.jpeg',
    tags: ['community'],
    metrics_list: [
      {
        captured_date: '2017-01-09T00:00:00.000Z',
        metrics: [
          { label: 'views', reach: 6200, is_manual: true },
          { label: 'reads', reach: 540, is_manual: true },
        ],
        fetched_via: 'manual',
      },
    ],
  },
  {
    title: '6 Apps One Code',
    type: 'speaking',
    source: 'slides',
    date: '2017-06-01T00:00:00.000Z',
    url: 'https://slides.com/saniyusuf/6-apps-one-code',
    thumbnail:
      'https://media.slid.es/thumbnails/9f50c75ed76b0d9115a04f1d5bd3d66c/thumb.jpg',
    tags: ['mobile'],
    metrics_list: [
      {
        captured_date: '2017-06-01T00:00:00.000Z',
        metrics: [{ label: 'views', reach: 4235, is_manual: false }],
        fetched_via: 'jina+claude+jsonld',
      },
    ],
  },
  {
    title: 'November MongoDB Meetup',
    type: 'speaking',
    source: 'meetup',
    date: '2025-11-06T18:00:00.000Z',
    url: 'https://www.meetup.com/mongodb-usergroup-london/events/311630307/',
    thumbnail:
      'https://secure-content.meetupstatic.com/images/classic-events/531004593/676x676.jpg',
    tags: ['data', 'community'],
    location: { place_name: 'London, United Kingdom', is_manual: true },
    metrics_list: [
      {
        captured_date: '2025-11-06T18:00:00.000Z',
        metrics: [{ label: 'attendees', reach: 80, is_manual: true }],
        fetched_via: 'manual',
      },
    ],
  },
];
